import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/trade/ship-metal/")({
  beforeLoad: () => {
    throw redirect({
      to: "/trade/ship-metal/product-list",
    });
  },
});
